import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, permission }) {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [branchId, setBranchId] = useState(null);

  useEffect(() => {
    fetch("/api/admin/me", {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setUser(data.admin);
          setPermissions(data.permissions || []);
          setBranchId(data.branch_id || null);
        } else {
          setUser(null);
        }
      })
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-black text-white">
        Checking authentication...
      </div>
    );
  }

  // ❌ Not logged in → default admin login
  if (!user) {
    return <Navigate to="/stafflogin" replace />;
  }

  // 🔥 SUPER ADMIN BYPASS
  if (user.role === "super_admin") {
    return children;
  }

  // 🔥 PERMISSION CHECK
  if (permission && !permissions.includes(permission)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
